import React from "react";
import { Menu } from "antd";
import { useSelector } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import Renderbtn from "../../pages/uih/wf_controllers/BtnController/renderButton";
import packageJson from "../../../package.json";
const { SubMenu } = Menu;

function SideNav(props) {
  // const { history } = props;
  const menu = useSelector((state) => state.metaData.dynamicMenu);
  const currentPath = window.location.pathname.split("/")[2];
  const onMenuclick = (url) => {
    if (url !== "") {
      // history.push(url);
    }
  };

  return (
    <div
      className="sidenav position-fixed"
      style={{ display: "flex", flexDirection: "column", zIndex: 200 }}
      id="mySidenav"
    >
      <div style={{ display: "flex", flex: 1, width: "200px" }}>
        <Menu
          defaultSelectedKeys={["/" + currentPath]}
          mode="inline"
          theme="light"
          // inlineCollapsed={this.state.collapsed}
        >
          {/* {sortMenu?.map((s) => genSideNavMenu(s))} */}
          {menu
            .sort((a, b) => a.menu_id - b.menu_id)
            ?.filter((s) => s.parent_menu_id === -1)
            .map((main) => {
              const sub = menu?.filter(
                (m) => m.parent_menu_id === main.menu_id
              );
              if (sub.length > 0) {
                return (
                  <SubMenu
                    key={main.menu_id}
                    title={
                      main.icon_type ? (
                        <Link to={main.url}>
                          <Renderbtn
                            renderBtn={{
                              ...main.icon_type,
                              text: main.menu_name,
                            }}
                            disable={true}
                            btnMiddleware={onMenuclick}
                            item={main.url}
                          ></Renderbtn>
                          {main.menu_name}
                        </Link>
                      ) : (
                        <>{main.menu_name}</>
                      )
                    }
                  >
                    {menu
                      .filter((p) => p.parent_menu_id === main.menu_id)
                      .map((chil) => {
                        const subMenu = menu.filter(
                          (sub) => sub.parent_menu_id === chil.menu_id
                        );
                        if (subMenu?.length > 0) {
                          return (
                            <SubMenu
                              key={chil.menu_id}
                              title={
                                chil.icon_type !== null ? (
                                  <Link to={chil.url}>
                                    <Renderbtn
                                      renderBtn={{
                                        ...chil.icon_type,
                                        text: chil.menu_name,
                                      }}
                                      disable={true}
                                      btnMiddleware={onMenuclick}
                                      item={chil.url}
                                    ></Renderbtn>
                                    {chil.menu_name}
                                  </Link>
                                ) : (
                                  <>{chil.menu_name}</>
                                )
                              }
                            >
                              {subMenu?.map((subM) => (
                                <Menu.Item
                                  key={subM.url}
                                  onClick={() => onMenuclick(subM.url)}
                                >
                                  {subM.icon_type ? (
                                    <Link to={subM.url}>
                                      <Renderbtn
                                        renderBtn={{
                                          ...subM.icon_type,
                                          text: subM.menu_name,
                                        }}
                                        disable={true}
                                        btnMiddleware={onMenuclick}
                                        item={subM.url}
                                      ></Renderbtn>
                                      {subM.menu_name}
                                    </Link>
                                  ) : (
                                    <>{subM.menu_name}</>
                                  )}
                                </Menu.Item>
                              ))}
                            </SubMenu>
                          );
                        }
                        return (
                          <Menu.Item
                            key={chil.url}
                            onClick={() => onMenuclick(chil.url)}
                          >
                            {chil.icon_type ? (
                              <Link to={chil.url}>
                                <Renderbtn
                                  renderBtn={{
                                    ...chil.icon_type,
                                    text: chil.menu_name,
                                  }}
                                  disable={true}
                                  btnMiddleware={onMenuclick}
                                  item={chil.url}
                                ></Renderbtn>
                                {chil.menu_name}
                              </Link>
                            ) : (
                              <>{chil.menu_name}</>
                            )}
                          </Menu.Item>
                        );
                      })}
                  </SubMenu>
                );
              } else {
                return (
                  <Menu.Item
                    key={main.url}
                    onClick={() => onMenuclick(main.url)}
                  >
                    {main.icon_type ? (
                      <Link to={main.url}>
                        <Renderbtn
                          renderBtn={{
                            ...main.icon_type,
                            text: main.menu_name,
                          }}
                          disable={true}
                          btnMiddleware={onMenuclick}
                          item={main.url}
                        ></Renderbtn>
                        {main.menu_name}
                      </Link>
                    ) : (
                      <Link to={main.url}>{main.menu_name}</Link>
                    )}
                  </Menu.Item>
                );
              }
            })}
        </Menu>
      </div>
      <div className="row" style={{ padding: "0 8px", width: "200px" }}>
        <div className="col">
          <label
            style={{ color: "#9d9d9d" }}
          >{`Version ${packageJson.version}`}</label>
        </div>
      </div>
    </div>
  );
}
export default withRouter(SideNav);
